import { Home } from '@/components/home/Home'

/** The home screen: your worlds (the new world first), then the pages. */
export function HomeScreen() {
  return <Home />
}
